export const liveTypes = {
  FETCH_LIVE_CONTENT: "FETCH_LIVE_CONTENT",
  FETCH_LIVE_CONTENT_START: "FETCH_LIVE_CONTENT_START",
  FETCH_LIVE_CONTENT_ERROR: "FETCH_LIVE_CONTENT_ERROR",
  POST_MESSAGE_START: "POST_MESSAGE_START",
  POST_MESSAGE_ERROR: "POST_MESSAGE_ERROR",
  POST_MESSAGE: "POST_MESSAGE",
  SET_LIVE_LOADING: "SET_LIVE_LOADING",
};
